import React, { useState } from 'react';
import { WorkflowInputLayout } from './WorkflowInputLayout';
import EconomicTab from '../../../components/utility_planning/scenarioInputs/EconomicTab';

const defaultEconomic = {
  touSource: 'library',
  touDatasetId: null,
  touRates: null,
  touRateMeta: null,
  touRateDetails: null,
  v2gMode: 'unmanaged',
  vehiclePricingDatasetId: null,
};

export default function VehiclePricingInputPage() {
  const [data, setData] = useState(defaultEconomic);
  const updateData = (next) => setData((prev) => ({ ...prev, ...next }));

  return (
    <WorkflowInputLayout title="Vehicle pricing">
      <div className="bg-white rounded-xl shadow-lg font-ui">
        <EconomicTab data={data} updateData={updateData} section="vehicle" />
      </div>
    </WorkflowInputLayout>
  );
}
